import type { TourStep } from './Types'

export const contentManagerTour: TourStep[] = [
	{
		id: 'sidebar',
		target: '[data-tour-id="content-sidebar"]',
		position: 'right',
		title: 'Your Library',
		content: 'Playbooks, presentations, and documents are organized here.',
	},
	{
		id: 'folders',
		target: '[data-tour-id="folder-tree"]',
		position: 'right',
		title: 'Folders',
		content: 'Create folders to organize your content. Drag items to move them.',
	},
	{
		id: 'content-grid',
		target: '[data-tour-id="content-grid"]',
		position: 'top',
		title: 'Your Content',
		content: 'Click any item to open it. Right-click for more options.',
	},
	{
		id: 'new-button',
		target: '[data-tour-id="new-button"]',
		position: 'bottom',
		title: 'Create New',
		content: 'Start a new playbook, presentation, or document here.',
	},
	{
		id: 'search',
		target: '[data-tour-id="search-input"]',
		position: 'bottom',
		title: 'Search',
		content: 'Quickly find any play, playbook, or content by name.',
	},
	{
		id: 'view-toggle',
		target: '[data-tour-id="view-toggle"]',
		position: 'left',
		title: 'Change View',
		content: 'Switch between grid and list views.',
	},
]
